module.exports = __webpack_public_path__ + "static/media/prod_70000_3.f7b4f1d1.jpg";